import { Button, ButtonGroup } from '@chakra-ui/react'

export const CalendarViewSwitcher = ({isCalendarView, setIsCalendarView}) => {
    return (
        <ButtonGroup size='sm' isAttached variant='outline' colorScheme='teal' aria-label='Countings view'>
            {['Table', 'Calendar'].map(option => {
                const selected = isCalendarView === (option === 'Calendar')

                return (
                    <Button
                        key={option}
                        variant={selected ? 'solid' : 'outline'}
                        aria-pressed={selected}
                        onClick={() => setIsCalendarView(option === 'Calendar')}
                    >
                        {option}
                    </Button>
                )
            })}
        </ButtonGroup>
    )
}
